import React from 'react'
import styles from './style/pagination_style.module.scss'

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    if (!totalPages || totalPages <= 1) return null

    const pages = Array.from({ length: totalPages }, (_, i) => i)

    return (
        <div className={styles['pagination']}>
            {/* Prev */}
            <button
                className={`${styles['pagination__button']} ${styles['pagination__button--nav']}`}
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 0}
                aria-label="Previous"
            >
                <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
            </button>

            {/* Page numbers */}
            {pages && pages.map((page) => (
                <button
                    key={page}
                    className={`${styles['pagination__button']}${page === currentPage ? ` ${styles['pagination__button--active']}` : ''}`}
                    onClick={() => onPageChange(page)}
                    aria-current={page === currentPage ? 'page' : undefined}
                >
                    {page + 1}
                </button>
            ))}

            {/* Next */}
            <button
                className={`${styles['pagination__button']} ${styles['pagination__button--nav']}`}
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages - 1}
                aria-label="Next"
            >
                <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
            </button>
        </div>
    )
}

export default Pagination